import { orgs } from '@/data/index'

export const getOrgByKey = (orgKey: string): Org|null => {
    const org = orgs[orgKey]
    if (!org) return null
    return org
}
